import React, { useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import Cookies from 'js-cookie';
import RotateToken from './components/common/rotateToken/RotateToken'
import LeadRouter from './routes/Lead';
import EnquiryRouter from './routes/Enquiry'
import InstallationRouter from './routes/Installation'
import ControllerRouter from './routes/Controller'
import WarehouseRouter from './routes/Warehouse';
import NotFound from './pages/not-found/NotFound ';
import { ttSv2Axios } from './config/axios';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from './redux/features/user/authSlice'

const Master = () => {
    const rfs_tkn = Cookies.get('_rfs_tkn');
    const DVC_ID = Cookies.get('DVC_ID');
    const dispatch = useDispatch()
    const location = useLocation();
    const { user } = useSelector((state) => state.userAuth)


    useEffect(() => {
        const firstSegment = location?.pathname?.split("/")[1] || 'error'
        if (DVC_ID && rfs_tkn) {
            ttSv2Axios.get('/worker/initial-info').then((response) => {
                let routeAuth = false
                switch (firstSegment) {
                    case 'lead':
                        if (response?.data?.allowed_origins?.some((access) => access?.slice(0, 9) === 'slur_lead')) {
                            routeAuth = true
                        }
                        break;
                    case 'enquiry':
                        if (response?.data?.allowed_origins?.some((access) => access?.slice(0, 8) === 'slur_eqr')) {
                            routeAuth = true
                        }
                        break;
                    case 'installation':
                        if (response?.data?.allowed_origins?.some((access) => access?.slice(0, 12) === 'slur_install')) {
                            routeAuth = true
                        }
                        break;
                    case 'warehouse':
                        if (response?.data?.allowed_origins?.some((access) => access?.slice(0, 9) === 'slur_gdwn')) {
                            routeAuth = true
                        }
                        break;
                    case 'controller':
                        if (response?.data?.allowed_origins?.some((access) => access?.slice(0, 4) === 'slcr')) {
                            routeAuth = true
                        }
                        break;
                    default:
                        break;
                }
                if (routeAuth) {
                    dispatch(setUser({ ...(user || {}), ...response.data, refresh_token: Cookies.get('_rfs_tkn') }))
                } else {
                    window.location.href = 'https://staff.alliancewatersolutions.com/?page=home'
                }
            }).catch(() => {
                window.location.href = 'https://staff.alliancewatersolutions.com/?page=home'
            })
        } else {
            window.location.href = 'https://staff.alliancewatersolutions.com/?page=home'
        }
        // eslint-disable-next-line
    }, [])


    return (
        <>
            <RotateToken />
            <Routes>
                {/* Without Header and Footer */}
                <Route path="/*" element={<NotFound setPageHead={() => null} />} />

                {/* Main Root */}
                <Route element={<LeadRouter />} path='/lead/*' />
                <Route element={<EnquiryRouter />} path='/enquiry/*' />
                <Route element={<InstallationRouter />} path='/installation/*' />
                <Route element={<WarehouseRouter />} path='/warehouse/*' />
                <Route element={<ControllerRouter />} path='/controller/*' />

            </Routes>
        </>
    )
}

export default Master